import { createReducer } from "redux-create-reducer";

import {
  CLEAR_SINGLE_CLIENT_REPORT_PDF,
  EXPORT_SINGLE_CLIENT_REPORT_PDF,
} from "../../types";

const initialState = {
  data: new Blob([], { type: "application/pdf" }),
  isLoading: false,
};

const exportSingleClientReportPdfReducer = createReducer(initialState, {
  [EXPORT_SINGLE_CLIENT_REPORT_PDF.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_SINGLE_CLIENT_REPORT_PDF.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_SINGLE_CLIENT_REPORT_PDF.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [EXPORT_SINGLE_CLIENT_REPORT_PDF.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: new Blob([payload.data], { type: "application/pdf" }),
    isLoading: false,
  }),
  [CLEAR_SINGLE_CLIENT_REPORT_PDF]: (state) => ({
    ...state,
    ...initialState,
  }),
});

export default exportSingleClientReportPdfReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/single-client/exportSingleClientReportPdfReducer.js